export enum PosthogGroupTypes {
    Company = 'company',
    Office = 'office',
}

export enum PosthogTransferDateSource {
    WaterTransferRealtorDashboard = 'Water Transfer Realtor Dashboard',
    BoilerMaintenanceTransactionDetails = 'Boiler Maintenance Transaction Details',
    MoverModal = 'Mover Modal',
    LeaverDashboard = 'Leaver Dashboard',
}

export enum PosthogREALocations {
    Homepage = 'Homepage',
    TransactionListview = 'Transaction Listview',
    TransactionDetail = 'Transaction Detail',
}

export enum PosthogREATodos {
    All = 'all',
    Energy = 'energy',
    Water = 'water',
}

export enum PosthogStatusServices {
    Water = 'Water',
    Energy = 'Energy',
    EnergyFinalInvoice = 'Energy Final Invoice',
    WaterTransfer = 'Water Transfer',
}

export enum PosthogReviewAction {
    Answer = 'Answer',
    InternalNote = 'Internal Note',
    ViewTransaction = 'View Transaction',
    Share = 'Share',
}

export enum PosthogReviewShareNetwork {
    LinkedIn = 'LinkedIn',
    Facebook = 'Facebook',
    Instagram = 'Instagram',
    Download = 'Download',
}

export enum PosthogNumbersPages {
    Overview = 'Overview',
    Input = 'Input',
    Confirmation = 'Confirmation',
}
